export default "__VITE_ASSET__C597_6GA__"